// extracted by mini-css-extract-plugin
export var chevron = "_io-2";
export var dropdownItems = "_io-0";
export var item = "_io-1";